module.exports = __webpack_public_path__ + "static/Mauer1.76958a86.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/MauerBack/Mauer1.png
// module id = 428
// module chunks = 35783957827783